var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.404 5.15403C25.965 4.65665 25.2833 4.38174 24.5332 4.87912L8.58681 14.8569L1.72199 12.7212C0.22826 12.2588 0.201245 11.237 2.03981 10.5251L28.8841 0.245368C30.1284 -0.217054 31.2153 0.520278 30.8101 2.40651L26.2415 23.8114C25.8966 25.3226 24.9972 25.6976 23.7212 24.9857L16.7626 19.8896L13.4049 23.0995C13.2398 23.3125 13.0276 23.4844 12.785 23.6019C12.5425 23.7193 12.276 23.779 12.0065 23.7764L12.5071 16.7336L25.404 5.15403Z",
    fill: "#47358D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.38650c3a66539ff9dfe4d5a522e38d55.svg";
export { ForwardRef as ReactComponent };